import { Action, EmailConfirmationError } from '../types';

export interface State {
  /** The email that the user currently has */
  email: string;
  /** The email that the user wants to change their current email _to_ */
  newEmail: string;
  /** The error (if any) that is returned from the backend. */
  error: EmailConfirmationError | null;
  /** Whether or not anything is loading (e.g. backend requests) */
  isLoading: boolean;
  /** The place to redirect the user to (if anywhere) if their request to change their email was successful. */
  redirectTo: string | null;
}

export const defaultState: State = {
  email: '',
  newEmail: '',
  error: null,
  isLoading: false,
  redirectTo: null,
};

const changeEmail = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'CHANGE_EMAIL_RESET_STATE':
      return defaultState;
    case 'CHANGE_EMAIL_REQUEST':
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case 'CHANGE_EMAIL_REQUEST_FAILED':
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case 'CHANGE_EMAIL_REQUEST_SUCCEEDED':
      return {
        ...state,
        redirectTo: action.redirectTo,
        isLoading: false,
      };
    case 'CHANGE_EMAIL_STATE_UPDATE':
      return {
        ...state,
        ...action.backendState,
      };
    default:
      return state;
  }
};

export default changeEmail;
